import { Box } from '@mui/material';

const EditDeliveryPartnerModalBody = () => <Box>Edit Delivery Partner</Box>;

export default EditDeliveryPartnerModalBody;
